/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as LoginLinkModalRouteImport } from './routes/login-link-modal'
import { Route as GroupLegalRouteRouteImport } from './routes/group-legal/route'
import { Route as EndUserRouteRouteImport } from './routes/end-user/route'
import { Route as BuAdminRouteRouteImport } from './routes/bu-admin/route'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as GroupLegalIndexRouteImport } from './routes/group-legal/index'
import { Route as EndUserIndexRouteImport } from './routes/end-user/index'
import { Route as BuAdminIndexRouteImport } from './routes/bu-admin/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as GroupLegalToolsRouteImport } from './routes/group-legal/tools'
import { Route as GroupLegalProductsRouteImport } from './routes/group-legal/products'
import { Route as GroupLegalEvaluationsRouteImport } from './routes/group-legal/evaluations'
import { Route as EndUserWaitingOnYouRouteImport } from './routes/end-user/waiting-on-you'
import { Route as EndUserToolsRouteImport } from './routes/end-user/tools'
import { Route as EndUserRequestAccessRouteImport } from './routes/end-user/request-access'
import { Route as EndUserMyToolsRouteImport } from './routes/end-user/my-tools'
import { Route as EndUserMyRequestsRouteImport } from './routes/end-user/my-requests'
import { Route as EndUserEvaluationStepsRouteImport } from './routes/end-user/evaluation-steps'
import { Route as EndUserDecisionsRouteImport } from './routes/end-user/decisions'
import { Route as EndUserApprovalsRouteImport } from './routes/end-user/approvals'
import { Route as BuAdminWorkflowsRouteImport } from './routes/bu-admin/workflows'
import { Route as BuAdminUsersRouteImport } from './routes/bu-admin/users'
import { Route as BuAdminToolsImportRouteImport } from './routes/bu-admin/tools-import'
import { Route as BuAdminToolsRouteImport } from './routes/bu-admin/tools'
import { Route as BuAdminRequestsRouteImport } from './routes/bu-admin/requests'
import { Route as BuAdminPoliciesRouteImport } from './routes/bu-admin/policies'
import { Route as BuAdminHousesRouteImport } from './routes/bu-admin/houses'
import { Route as BuAdminGroupContractsRouteImport } from './routes/bu-admin/group-contracts'
import { Route as BuAdminEmailTemplatesRouteImport } from './routes/bu-admin/email-templates'
import { Route as BuAdminConnectorsRouteImport } from './routes/bu-admin/connectors'
import { Route as BuAdminAnalyticsRouteImport } from './routes/bu-admin/analytics'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminProductsRouteImport } from './routes/admin/products'
import { Route as AdminCategoriesRouteImport } from './routes/admin/categories'
import { Route as AdminCatalogueRouteImport } from './routes/admin/catalogue'
import { Route as AdminBugReportsRouteImport } from './routes/admin/bug-reports'
import { Route as AdminAuditLogsRouteImport } from './routes/admin/audit-logs'
import { Route as GroupLegalProductsProductKeyRouteImport } from './routes/group-legal/products_.$productKey'

const NoAccessLazyRouteImport = createFileRoute('/no-access')()
const LoginLinkLazyRouteImport = createFileRoute('/login-link')()
const LoginLazyRouteImport = createFileRoute('/login')()
const HomeLazyRouteImport = createFileRoute('/home')()
const HelpLazyRouteImport = createFileRoute('/help')()
const IndexLazyRouteImport = createFileRoute('/')()
const GroupLegalRequestsLazyRouteImport = createFileRoute(
  '/group-legal/requests',
)()
const GroupLegalPendingLazyRouteImport = createFileRoute(
  '/group-legal/pending',
)()
const GroupLegalNegotiationLazyRouteImport = createFileRoute(
  '/group-legal/negotiation',
)()
const GroupLegalDeclinedLazyRouteImport = createFileRoute(
  '/group-legal/declined',
)()
const GroupLegalDashboardLazyRouteImport = createFileRoute(
  '/group-legal/dashboard',
)()
const GroupLegalContractedLazyRouteImport = createFileRoute(
  '/group-legal/contracted',
)()
const EndUserSettingsLazyRouteImport = createFileRoute('/end-user/settings')()
const EndUserPoliciesLazyRouteImport = createFileRoute('/end-user/policies')()
const EndUserDashboardLazyRouteImport = createFileRoute('/end-user/dashboard')()
const EndUserCommunityLazyRouteImport = createFileRoute('/end-user/community')()
const BuAdminSettingsLazyRouteImport = createFileRoute('/bu-admin/settings')()
const BuAdminEvaluationStepsLazyRouteImport = createFileRoute(
  '/bu-admin/evaluation-steps',
)()
const BuAdminDashboardLazyRouteImport = createFileRoute('/bu-admin/dashboard')()
const AdminWebConfigLazyRouteImport = createFileRoute('/admin/web-config')()
const AdminToolsLazyRouteImport = createFileRoute('/admin/tools')()
const AdminSettingsLazyRouteImport = createFileRoute('/admin/settings')()
const AdminPoliciesLazyRouteImport = createFileRoute('/admin/policies')()
const AdminGroupContractsLazyRouteImport = createFileRoute(
  '/admin/group-contracts',
)()
const AdminDomainsLazyRouteImport = createFileRoute('/admin/domains')()
const AdminDashboardLazyRouteImport = createFileRoute('/admin/dashboard')()
const AdminConnectorsLazyRouteImport = createFileRoute('/admin/connectors')()
const AdminBusinessUnitsLazyRouteImport = createFileRoute(
  '/admin/business-units',
)()
const AdminAnalyticsLazyRouteImport = createFileRoute('/admin/analytics')()
const AdminAdministratorsLazyRouteImport = createFileRoute(
  '/admin/administrators',
)()
const GroupLegalToolsProductKeyLazyRouteImport = createFileRoute(
  '/group-legal/tools_/$productKey',
)()
const EndUserToolsToolIdLazyRouteImport = createFileRoute(
  '/end-user/tools_/$toolId',
)()
const EndUserMyRequestsRequestIdLazyRouteImport = createFileRoute(
  '/end-user/my-requests_/$requestId',
)()
const EndUserDecisionsRequestIdLazyRouteImport = createFileRoute(
  '/end-user/decisions_/$requestId',
)()
const BuAdminToolsToolIdLazyRouteImport = createFileRoute(
  '/bu-admin/tools_/$toolId',
)()
const BuAdminRequestsRequestIdLazyRouteImport = createFileRoute(
  '/bu-admin/requests_/$requestId',
)()
const AdminCatalogueImportLazyRouteImport = createFileRoute(
  '/admin/catalogue_/import',
)()

const NoAccessLazyRoute = NoAccessLazyRouteImport.update({
  id: '/no-access',
  path: '/no-access',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/no-access.lazy').then((d) => d.Route))
const LoginLinkLazyRoute = LoginLinkLazyRouteImport.update({
  id: '/login-link',
  path: '/login-link',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/login-link.lazy').then((d) => d.Route))
const LoginLazyRoute = LoginLazyRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/login.lazy').then((d) => d.Route))
const HomeLazyRoute = HomeLazyRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/home.lazy').then((d) => d.Route))
const HelpLazyRoute = HelpLazyRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/help.lazy').then((d) => d.Route))
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/onboarding.lazy').then((d) => d.Route))
const LoginLinkModalRoute = LoginLinkModalRouteImport.update({
  id: '/login-link-modal',
  path: '/login-link-modal',
  getParentRoute: () => rootRouteImport,
} as any)
const GroupLegalRouteRoute = GroupLegalRouteRouteImport.update({
  id: '/group-legal',
  path: '/group-legal',
  getParentRoute: () => rootRouteImport,
} as any)
const EndUserRouteRoute = EndUserRouteRouteImport.update({
  id: '/end-user',
  path: '/end-user',
  getParentRoute: () => rootRouteImport,
} as any)
const BuAdminRouteRoute = BuAdminRouteRouteImport.update({
  id: '/bu-admin',
  path: '/bu-admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexLazyRoute = IndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const GroupLegalIndexRoute = GroupLegalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => GroupLegalRouteRoute,
} as any)
const EndUserIndexRoute = EndUserIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => EndUserRouteRoute,
} as any)
const BuAdminIndexRoute = BuAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BuAdminRouteRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const GroupLegalRequestsLazyRoute = GroupLegalRequestsLazyRouteImport.update({
  id: '/requests',
  path: '/requests',
  getParentRoute: () => GroupLegalRouteRoute,
} as any).lazy(() =>
  import('./routes/group-legal/requests.lazy').then((d) => d.Route),
)
const GroupLegalPendingLazyRoute = GroupLegalPendingLazyRouteImport.update({
  id: '/pending',
  path: '/pending',
  getParentRoute: () => GroupLegalRouteRoute,
} as any).lazy(() =>
  import('./routes/group-legal/pending.lazy').then((d) => d.Route),
)
const GroupLegalNegotiationLazyRoute =
  GroupLegalNegotiationLazyRouteImport.update({
    id: '/negotiation',
    path: '/negotiation',
    getParentRoute: () => GroupLegalRouteRoute,
  } as any).lazy(() =>
    import('./routes/group-legal/negotiation.lazy').then((d) => d.Route),
  )
const GroupLegalDeclinedLazyRoute = GroupLegalDeclinedLazyRouteImport.update({
  id: '/declined',
  path: '/declined',
  getParentRoute: () => GroupLegalRouteRoute,
} as any).lazy(() =>
  import('./routes/group-legal/declined.lazy').then((d) => d.Route),
)
const GroupLegalDashboardLazyRoute = GroupLegalDashboardLazyRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => GroupLegalRouteRoute,
} as any).lazy(() =>
  import('./routes/group-legal/dashboard.lazy').then((d) => d.Route),
)
const GroupLegalContractedLazyRoute =
  GroupLegalContractedLazyRouteImport.update({
    id: '/contracted',
    path: '/contracted',
    getParentRoute: () => GroupLegalRouteRoute,
  } as any).lazy(() =>
    import('./routes/group-legal/contracted.lazy').then((d) => d.Route),
  )
const EndUserSettingsLazyRoute = EndUserSettingsLazyRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => EndUserRouteRoute,
} as any).lazy(() =>
  import('./routes/end-user/settings.lazy').then((d) => d.Route),
)
const EndUserPoliciesLazyRoute = EndUserPoliciesLazyRouteImport.update({
  id: '/policies',
  path: '/policies',
  getParentRoute: () => EndUserRouteRoute,
} as any).lazy(() =>
  import('./routes/end-user/policies.lazy').then((d) => d.Route),
)
const EndUserDashboardLazyRoute = EndUserDashboardLazyRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => EndUserRouteRoute,
} as any).lazy(() =>
  import('./routes/end-user/dashboard.lazy').then((d) => d.Route),
)
const EndUserCommunityLazyRoute = EndUserCommunityLazyRouteImport.update({
  id: '/community',
  path: '/community',
  getParentRoute: () => EndUserRouteRoute,
} as any).lazy(() =>
  import('./routes/end-user/community.lazy').then((d) => d.Route),
)
const BuAdminSettingsLazyRoute = BuAdminSettingsLazyRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => BuAdminRouteRoute,
} as any).lazy(() =>
  import('./routes/bu-admin/settings.lazy').then((d) => d.Route),
)
const BuAdminEvaluationStepsLazyRoute =
  BuAdminEvaluationStepsLazyRouteImport.update({
    id: '/evaluation-steps',
    path: '/evaluation-steps',
    getParentRoute: () => BuAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/bu-admin/evaluation-steps.lazy').then((d) => d.Route),
  )
const BuAdminDashboardLazyRoute = BuAdminDashboardLazyRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => BuAdminRouteRoute,
} as any).lazy(() =>
  import('./routes/bu-admin/dashboard.lazy').then((d) => d.Route),
)
const AdminWebConfigLazyRoute = AdminWebConfigLazyRouteImport.update({
  id: '/web-config',
  path: '/web-config',
  getParentRoute: () => AdminRouteRoute,
} as any).lazy(() =>
  import('./routes/admin/web-config.lazy').then((d) => d.Route),
)
const AdminToolsLazyRoute = AdminToolsLazyRouteImport.update({
  id: '/tools',
  path: '/tools',
  getParentRoute: () => AdminRouteRoute,
} as any).lazy(() => import('./routes/admin/tools.lazy').then((d) => d.Route))
const AdminSettingsLazyRoute = AdminSettingsLazyRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRouteRoute,
} as any).lazy(() =>
  import('./routes/admin/settings.lazy').then((d) => d.Route),
)
const AdminPoliciesLazyRoute = AdminPoliciesLazyRouteImport.update({
  id: '/policies',
  path: '/policies',
  getParentRoute: () => AdminRouteRoute,
} as any).lazy(() =>
  import('./routes/admin/policies.lazy').then((d) => d.Route),
)
const AdminGroupContractsLazyRoute = AdminGroupContractsLazyRouteImport.update({
  id: '/group-contracts',
  path: '/group-contracts',
  getParentRoute: () => AdminRouteRoute,
} as any).lazy(() =>
  import('./routes/admin/group-contracts.lazy').then((d) => d.Route),
)
const AdminDomainsLazyRoute = AdminDomainsLazyRouteImport.update({
  id: '/domains',
  path: '/domains',
  getParentRoute: () => AdminRouteRoute,
} as any).lazy(() => import('./routes/admin/domains.lazy').then((d) => d.Route))
const AdminDashboardLazyRoute = AdminDashboardLazyRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AdminRouteRoute,
} as any).lazy(() =>
  import('./routes/admin/dashboard.lazy').then((d) => d.Route),
)
const AdminConnectorsLazyRoute = AdminConnectorsLazyRouteImport.update({
  id: '/connectors',
  path: '/connectors',
  getParentRoute: () => AdminRouteRoute,
} as any).lazy(() =>
  import('./routes/admin/connectors.lazy').then((d) => d.Route),
)
const AdminBusinessUnitsLazyRoute = AdminBusinessUnitsLazyRouteImport.update({
  id: '/business-units',
  path: '/business-units',
  getParentRoute: () => AdminRouteRoute,
} as any).lazy(() =>
  import('./routes/admin/business-units.lazy').then((d) => d.Route),
)
const AdminAnalyticsLazyRoute = AdminAnalyticsLazyRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AdminRouteRoute,
} as any).lazy(() =>
  import('./routes/admin/analytics.lazy').then((d) => d.Route),
)
const AdminAdministratorsLazyRoute = AdminAdministratorsLazyRouteImport.update({
  id: '/administrators',
  path: '/administrators',
  getParentRoute: () => AdminRouteRoute,
} as any).lazy(() =>
  import('./routes/admin/administrators.lazy').then((d) => d.Route),
)
const GroupLegalToolsRoute = GroupLegalToolsRouteImport.update({
  id: '/tools',
  path: '/tools',
  getParentRoute: () => GroupLegalRouteRoute,
} as any).lazy(() =>
  import('./routes/group-legal/tools.lazy').then((d) => d.Route),
)
const GroupLegalProductsRoute = GroupLegalProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => GroupLegalRouteRoute,
} as any)
const GroupLegalEvaluationsRoute = GroupLegalEvaluationsRouteImport.update({
  id: '/evaluations',
  path: '/evaluations',
  getParentRoute: () => GroupLegalRouteRoute,
} as any).lazy(() =>
  import('./routes/group-legal/evaluations.lazy').then((d) => d.Route),
)
const EndUserWaitingOnYouRoute = EndUserWaitingOnYouRouteImport.update({
  id: '/waiting-on-you',
  path: '/waiting-on-you',
  getParentRoute: () => EndUserRouteRoute,
} as any).lazy(() =>
  import('./routes/end-user/waiting-on-you.lazy').then((d) => d.Route),
)
const EndUserToolsRoute = EndUserToolsRouteImport.update({
  id: '/tools',
  path: '/tools',
  getParentRoute: () => EndUserRouteRoute,
} as any).lazy(() =>
  import('./routes/end-user/tools.lazy').then((d) => d.Route),
)
const EndUserRequestAccessRoute = EndUserRequestAccessRouteImport.update({
  id: '/request-access',
  path: '/request-access',
  getParentRoute: () => EndUserRouteRoute,
} as any).lazy(() =>
  import('./routes/end-user/request-access.lazy').then((d) => d.Route),
)
const EndUserMyToolsRoute = EndUserMyToolsRouteImport.update({
  id: '/my-tools',
  path: '/my-tools',
  getParentRoute: () => EndUserRouteRoute,
} as any).lazy(() =>
  import('./routes/end-user/my-tools.lazy').then((d) => d.Route),
)
const EndUserMyRequestsRoute = EndUserMyRequestsRouteImport.update({
  id: '/my-requests',
  path: '/my-requests',
  getParentRoute: () => EndUserRouteRoute,
} as any).lazy(() =>
  import('./routes/end-user/my-requests.lazy').then((d) => d.Route),
)
const EndUserEvaluationStepsRoute = EndUserEvaluationStepsRouteImport.update({
  id: '/evaluation-steps',
  path: '/evaluation-steps',
  getParentRoute: () => EndUserRouteRoute,
} as any)
const EndUserDecisionsRoute = EndUserDecisionsRouteImport.update({
  id: '/decisions',
  path: '/decisions',
  getParentRoute: () => EndUserRouteRoute,
} as any)
const EndUserApprovalsRoute = EndUserApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => EndUserRouteRoute,
} as any)
const BuAdminWorkflowsRoute = BuAdminWorkflowsRouteImport.update({
  id: '/workflows',
  path: '/workflows',
  getParentRoute: () => BuAdminRouteRoute,
} as any)
const BuAdminUsersRoute = BuAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => BuAdminRouteRoute,
} as any).lazy(() =>
  import('./routes/bu-admin/users.lazy').then((d) => d.Route),
)
const BuAdminToolsImportRoute = BuAdminToolsImportRouteImport.update({
  id: '/tools-import',
  path: '/tools-import',
  getParentRoute: () => BuAdminRouteRoute,
} as any).lazy(() =>
  import('./routes/bu-admin/tools-import.lazy').then((d) => d.Route),
)
const BuAdminToolsRoute = BuAdminToolsRouteImport.update({
  id: '/tools',
  path: '/tools',
  getParentRoute: () => BuAdminRouteRoute,
} as any).lazy(() =>
  import('./routes/bu-admin/tools.lazy').then((d) => d.Route),
)
const BuAdminRequestsRoute = BuAdminRequestsRouteImport.update({
  id: '/requests',
  path: '/requests',
  getParentRoute: () => BuAdminRouteRoute,
} as any).lazy(() =>
  import('./routes/bu-admin/requests.lazy').then((d) => d.Route),
)
const BuAdminPoliciesRoute = BuAdminPoliciesRouteImport.update({
  id: '/policies',
  path: '/policies',
  getParentRoute: () => BuAdminRouteRoute,
} as any).lazy(() =>
  import('./routes/bu-admin/policies.lazy').then((d) => d.Route),
)
const BuAdminHousesRoute = BuAdminHousesRouteImport.update({
  id: '/houses',
  path: '/houses',
  getParentRoute: () => BuAdminRouteRoute,
} as any).lazy(() =>
  import('./routes/bu-admin/houses.lazy').then((d) => d.Route),
)
const BuAdminGroupContractsRoute = BuAdminGroupContractsRouteImport.update({
  id: '/group-contracts',
  path: '/group-contracts',
  getParentRoute: () => BuAdminRouteRoute,
} as any).lazy(() =>
  import('./routes/bu-admin/group-contracts.lazy').then((d) => d.Route),
)
const BuAdminEmailTemplatesRoute = BuAdminEmailTemplatesRouteImport.update({
  id: '/email-templates',
  path: '/email-templates',
  getParentRoute: () => BuAdminRouteRoute,
} as any).lazy(() =>
  import('./routes/bu-admin/email-templates.lazy').then((d) => d.Route),
)
const BuAdminConnectorsRoute = BuAdminConnectorsRouteImport.update({
  id: '/connectors',
  path: '/connectors',
  getParentRoute: () => BuAdminRouteRoute,
} as any).lazy(() =>
  import('./routes/bu-admin/connectors.lazy').then((d) => d.Route),
)
const BuAdminAnalyticsRoute = BuAdminAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => BuAdminRouteRoute,
} as any).lazy(() =>
  import('./routes/bu-admin/analytics.lazy').then((d) => d.Route),
)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRouteRoute,
} as any).lazy(() => import('./routes/admin/users.lazy').then((d) => d.Route))
const AdminProductsRoute = AdminProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminCategoriesRoute = AdminCategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => AdminRouteRoute,
} as any).lazy(() =>
  import('./routes/admin/categories.lazy').then((d) => d.Route),
)
const AdminCatalogueRoute = AdminCatalogueRouteImport.update({
  id: '/catalogue',
  path: '/catalogue',
  getParentRoute: () => AdminRouteRoute,
} as any).lazy(() =>
  import('./routes/admin/catalogue.lazy').then((d) => d.Route),
)
const AdminBugReportsRoute = AdminBugReportsRouteImport.update({
  id: '/bug-reports',
  path: '/bug-reports',
  getParentRoute: () => AdminRouteRoute,
} as any).lazy(() =>
  import('./routes/admin/bug-reports.lazy').then((d) => d.Route),
)
const AdminAuditLogsRoute = AdminAuditLogsRouteImport.update({
  id: '/audit-logs',
  path: '/audit-logs',
  getParentRoute: () => AdminRouteRoute,
} as any).lazy(() =>
  import('./routes/admin/audit-logs.lazy').then((d) => d.Route),
)
const GroupLegalToolsProductKeyLazyRoute =
  GroupLegalToolsProductKeyLazyRouteImport.update({
    id: '/tools_/$productKey',
    path: '/tools/$productKey',
    getParentRoute: () => GroupLegalRouteRoute,
  } as any).lazy(() =>
    import('./routes/group-legal/tools_.$productKey.lazy').then((d) => d.Route),
  )
const EndUserToolsToolIdLazyRoute = EndUserToolsToolIdLazyRouteImport.update({
  id: '/tools_/$toolId',
  path: '/tools/$toolId',
  getParentRoute: () => EndUserRouteRoute,
} as any).lazy(() =>
  import('./routes/end-user/tools_.$toolId.lazy').then((d) => d.Route),
)
const EndUserMyRequestsRequestIdLazyRoute =
  EndUserMyRequestsRequestIdLazyRouteImport.update({
    id: '/my-requests_/$requestId',
    path: '/my-requests/$requestId',
    getParentRoute: () => EndUserRouteRoute,
  } as any).lazy(() =>
    import('./routes/end-user/my-requests_.$requestId.lazy').then(
      (d) => d.Route,
    ),
  )
const EndUserDecisionsRequestIdLazyRoute =
  EndUserDecisionsRequestIdLazyRouteImport.update({
    id: '/decisions_/$requestId',
    path: '/decisions/$requestId',
    getParentRoute: () => EndUserRouteRoute,
  } as any).lazy(() =>
    import('./routes/end-user/decisions_.$requestId.lazy').then((d) => d.Route),
  )
const BuAdminToolsToolIdLazyRoute = BuAdminToolsToolIdLazyRouteImport.update({
  id: '/tools_/$toolId',
  path: '/tools/$toolId',
  getParentRoute: () => BuAdminRouteRoute,
} as any).lazy(() =>
  import('./routes/bu-admin/tools_.$toolId.lazy').then((d) => d.Route),
)
const BuAdminRequestsRequestIdLazyRoute =
  BuAdminRequestsRequestIdLazyRouteImport.update({
    id: '/requests_/$requestId',
    path: '/requests/$requestId',
    getParentRoute: () => BuAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/bu-admin/requests_.$requestId.lazy').then((d) => d.Route),
  )
const AdminCatalogueImportLazyRoute =
  AdminCatalogueImportLazyRouteImport.update({
    id: '/catalogue_/import',
    path: '/catalogue/import',
    getParentRoute: () => AdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/admin/catalogue_.import.lazy').then((d) => d.Route),
  )
const GroupLegalProductsProductKeyRoute =
  GroupLegalProductsProductKeyRouteImport.update({
    id: '/products_/$productKey',
    path: '/products/$productKey',
    getParentRoute: () => GroupLegalRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/bu-admin': typeof BuAdminRouteRouteWithChildren
  '/end-user': typeof EndUserRouteRouteWithChildren
  '/group-legal': typeof GroupLegalRouteRouteWithChildren
  '/login-link-modal': typeof LoginLinkModalRoute
  '/onboarding': typeof OnboardingRoute
  '/help': typeof HelpLazyRoute
  '/home': typeof HomeLazyRoute
  '/login': typeof LoginLazyRoute
  '/login-link': typeof LoginLinkLazyRoute
  '/no-access': typeof NoAccessLazyRoute
  '/admin/audit-logs': typeof AdminAuditLogsRoute
  '/admin/bug-reports': typeof AdminBugReportsRoute
  '/admin/catalogue': typeof AdminCatalogueRoute
  '/admin/categories': typeof AdminCategoriesRoute
  '/admin/products': typeof AdminProductsRoute
  '/admin/users': typeof AdminUsersRoute
  '/bu-admin/analytics': typeof BuAdminAnalyticsRoute
  '/bu-admin/connectors': typeof BuAdminConnectorsRoute
  '/bu-admin/email-templates': typeof BuAdminEmailTemplatesRoute
  '/bu-admin/group-contracts': typeof BuAdminGroupContractsRoute
  '/bu-admin/houses': typeof BuAdminHousesRoute
  '/bu-admin/policies': typeof BuAdminPoliciesRoute
  '/bu-admin/requests': typeof BuAdminRequestsRoute
  '/bu-admin/tools': typeof BuAdminToolsRoute
  '/bu-admin/tools-import': typeof BuAdminToolsImportRoute
  '/bu-admin/users': typeof BuAdminUsersRoute
  '/bu-admin/workflows': typeof BuAdminWorkflowsRoute
  '/end-user/approvals': typeof EndUserApprovalsRoute
  '/end-user/decisions': typeof EndUserDecisionsRoute
  '/end-user/evaluation-steps': typeof EndUserEvaluationStepsRoute
  '/end-user/my-requests': typeof EndUserMyRequestsRoute
  '/end-user/my-tools': typeof EndUserMyToolsRoute
  '/end-user/request-access': typeof EndUserRequestAccessRoute
  '/end-user/tools': typeof EndUserToolsRoute
  '/end-user/waiting-on-you': typeof EndUserWaitingOnYouRoute
  '/group-legal/evaluations': typeof GroupLegalEvaluationsRoute
  '/group-legal/products': typeof GroupLegalProductsRoute
  '/group-legal/tools': typeof GroupLegalToolsRoute
  '/admin/administrators': typeof AdminAdministratorsLazyRoute
  '/admin/analytics': typeof AdminAnalyticsLazyRoute
  '/admin/business-units': typeof AdminBusinessUnitsLazyRoute
  '/admin/connectors': typeof AdminConnectorsLazyRoute
  '/admin/dashboard': typeof AdminDashboardLazyRoute
  '/admin/domains': typeof AdminDomainsLazyRoute
  '/admin/group-contracts': typeof AdminGroupContractsLazyRoute
  '/admin/policies': typeof AdminPoliciesLazyRoute
  '/admin/settings': typeof AdminSettingsLazyRoute
  '/admin/tools': typeof AdminToolsLazyRoute
  '/admin/web-config': typeof AdminWebConfigLazyRoute
  '/bu-admin/dashboard': typeof BuAdminDashboardLazyRoute
  '/bu-admin/evaluation-steps': typeof BuAdminEvaluationStepsLazyRoute
  '/bu-admin/settings': typeof BuAdminSettingsLazyRoute
  '/end-user/community': typeof EndUserCommunityLazyRoute
  '/end-user/dashboard': typeof EndUserDashboardLazyRoute
  '/end-user/policies': typeof EndUserPoliciesLazyRoute
  '/end-user/settings': typeof EndUserSettingsLazyRoute
  '/group-legal/contracted': typeof GroupLegalContractedLazyRoute
  '/group-legal/dashboard': typeof GroupLegalDashboardLazyRoute
  '/group-legal/declined': typeof GroupLegalDeclinedLazyRoute
  '/group-legal/negotiation': typeof GroupLegalNegotiationLazyRoute
  '/group-legal/pending': typeof GroupLegalPendingLazyRoute
  '/group-legal/requests': typeof GroupLegalRequestsLazyRoute
  '/admin/': typeof AdminIndexRoute
  '/bu-admin/': typeof BuAdminIndexRoute
  '/end-user/': typeof EndUserIndexRoute
  '/group-legal/': typeof GroupLegalIndexRoute
  '/group-legal/products/$productKey': typeof GroupLegalProductsProductKeyRoute
  '/admin/catalogue/import': typeof AdminCatalogueImportLazyRoute
  '/bu-admin/requests/$requestId': typeof BuAdminRequestsRequestIdLazyRoute
  '/bu-admin/tools/$toolId': typeof BuAdminToolsToolIdLazyRoute
  '/end-user/decisions/$requestId': typeof EndUserDecisionsRequestIdLazyRoute
  '/end-user/my-requests/$requestId': typeof EndUserMyRequestsRequestIdLazyRoute
  '/end-user/tools/$toolId': typeof EndUserToolsToolIdLazyRoute
  '/group-legal/tools/$productKey': typeof GroupLegalToolsProductKeyLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/login-link-modal': typeof LoginLinkModalRoute
  '/onboarding': typeof OnboardingRoute
  '/help': typeof HelpLazyRoute
  '/home': typeof HomeLazyRoute
  '/login': typeof LoginLazyRoute
  '/login-link': typeof LoginLinkLazyRoute
  '/no-access': typeof NoAccessLazyRoute
  '/admin/audit-logs': typeof AdminAuditLogsRoute
  '/admin/bug-reports': typeof AdminBugReportsRoute
  '/admin/catalogue': typeof AdminCatalogueRoute
  '/admin/categories': typeof AdminCategoriesRoute
  '/admin/products': typeof AdminProductsRoute
  '/admin/users': typeof AdminUsersRoute
  '/bu-admin/analytics': typeof BuAdminAnalyticsRoute
  '/bu-admin/connectors': typeof BuAdminConnectorsRoute
  '/bu-admin/email-templates': typeof BuAdminEmailTemplatesRoute
  '/bu-admin/group-contracts': typeof BuAdminGroupContractsRoute
  '/bu-admin/houses': typeof BuAdminHousesRoute
  '/bu-admin/policies': typeof BuAdminPoliciesRoute
  '/bu-admin/requests': typeof BuAdminRequestsRoute
  '/bu-admin/tools': typeof BuAdminToolsRoute
  '/bu-admin/tools-import': typeof BuAdminToolsImportRoute
  '/bu-admin/users': typeof BuAdminUsersRoute
  '/bu-admin/workflows': typeof BuAdminWorkflowsRoute
  '/end-user/approvals': typeof EndUserApprovalsRoute
  '/end-user/decisions': typeof EndUserDecisionsRoute
  '/end-user/evaluation-steps': typeof EndUserEvaluationStepsRoute
  '/end-user/my-requests': typeof EndUserMyRequestsRoute
  '/end-user/my-tools': typeof EndUserMyToolsRoute
  '/end-user/request-access': typeof EndUserRequestAccessRoute
  '/end-user/tools': typeof EndUserToolsRoute
  '/end-user/waiting-on-you': typeof EndUserWaitingOnYouRoute
  '/group-legal/evaluations': typeof GroupLegalEvaluationsRoute
  '/group-legal/products': typeof GroupLegalProductsRoute
  '/group-legal/tools': typeof GroupLegalToolsRoute
  '/admin/administrators': typeof AdminAdministratorsLazyRoute
  '/admin/analytics': typeof AdminAnalyticsLazyRoute
  '/admin/business-units': typeof AdminBusinessUnitsLazyRoute
  '/admin/connectors': typeof AdminConnectorsLazyRoute
  '/admin/dashboard': typeof AdminDashboardLazyRoute
  '/admin/domains': typeof AdminDomainsLazyRoute
  '/admin/group-contracts': typeof AdminGroupContractsLazyRoute
  '/admin/policies': typeof AdminPoliciesLazyRoute
  '/admin/settings': typeof AdminSettingsLazyRoute
  '/admin/tools': typeof AdminToolsLazyRoute
  '/admin/web-config': typeof AdminWebConfigLazyRoute
  '/bu-admin/dashboard': typeof BuAdminDashboardLazyRoute
  '/bu-admin/evaluation-steps': typeof BuAdminEvaluationStepsLazyRoute
  '/bu-admin/settings': typeof BuAdminSettingsLazyRoute
  '/end-user/community': typeof EndUserCommunityLazyRoute
  '/end-user/dashboard': typeof EndUserDashboardLazyRoute
  '/end-user/policies': typeof EndUserPoliciesLazyRoute
  '/end-user/settings': typeof EndUserSettingsLazyRoute
  '/group-legal/contracted': typeof GroupLegalContractedLazyRoute
  '/group-legal/dashboard': typeof GroupLegalDashboardLazyRoute
  '/group-legal/declined': typeof GroupLegalDeclinedLazyRoute
  '/group-legal/negotiation': typeof GroupLegalNegotiationLazyRoute
  '/group-legal/pending': typeof GroupLegalPendingLazyRoute
  '/group-legal/requests': typeof GroupLegalRequestsLazyRoute
  '/admin': typeof AdminIndexRoute
  '/bu-admin': typeof BuAdminIndexRoute
  '/end-user': typeof EndUserIndexRoute
  '/group-legal': typeof GroupLegalIndexRoute
  '/group-legal/products/$productKey': typeof GroupLegalProductsProductKeyRoute
  '/admin/catalogue/import': typeof AdminCatalogueImportLazyRoute
  '/bu-admin/requests/$requestId': typeof BuAdminRequestsRequestIdLazyRoute
  '/bu-admin/tools/$toolId': typeof BuAdminToolsToolIdLazyRoute
  '/end-user/decisions/$requestId': typeof EndUserDecisionsRequestIdLazyRoute
  '/end-user/my-requests/$requestId': typeof EndUserMyRequestsRequestIdLazyRoute
  '/end-user/tools/$toolId': typeof EndUserToolsToolIdLazyRoute
  '/group-legal/tools/$productKey': typeof GroupLegalToolsProductKeyLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexLazyRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/bu-admin': typeof BuAdminRouteRouteWithChildren
  '/end-user': typeof EndUserRouteRouteWithChildren
  '/group-legal': typeof GroupLegalRouteRouteWithChildren
  '/login-link-modal': typeof LoginLinkModalRoute
  '/onboarding': typeof OnboardingRoute
  '/help': typeof HelpLazyRoute
  '/home': typeof HomeLazyRoute
  '/login': typeof LoginLazyRoute
  '/login-link': typeof LoginLinkLazyRoute
  '/no-access': typeof NoAccessLazyRoute
  '/admin/audit-logs': typeof AdminAuditLogsRoute
  '/admin/bug-reports': typeof AdminBugReportsRoute
  '/admin/catalogue': typeof AdminCatalogueRoute
  '/admin/categories': typeof AdminCategoriesRoute
  '/admin/products': typeof AdminProductsRoute
  '/admin/users': typeof AdminUsersRoute
  '/bu-admin/analytics': typeof BuAdminAnalyticsRoute
  '/bu-admin/connectors': typeof BuAdminConnectorsRoute
  '/bu-admin/email-templates': typeof BuAdminEmailTemplatesRoute
  '/bu-admin/group-contracts': typeof BuAdminGroupContractsRoute
  '/bu-admin/houses': typeof BuAdminHousesRoute
  '/bu-admin/policies': typeof BuAdminPoliciesRoute
  '/bu-admin/requests': typeof BuAdminRequestsRoute
  '/bu-admin/tools': typeof BuAdminToolsRoute
  '/bu-admin/tools-import': typeof BuAdminToolsImportRoute
  '/bu-admin/users': typeof BuAdminUsersRoute
  '/bu-admin/workflows': typeof BuAdminWorkflowsRoute
  '/end-user/approvals': typeof EndUserApprovalsRoute
  '/end-user/decisions': typeof EndUserDecisionsRoute
  '/end-user/evaluation-steps': typeof EndUserEvaluationStepsRoute
  '/end-user/my-requests': typeof EndUserMyRequestsRoute
  '/end-user/my-tools': typeof EndUserMyToolsRoute
  '/end-user/request-access': typeof EndUserRequestAccessRoute
  '/end-user/tools': typeof EndUserToolsRoute
  '/end-user/waiting-on-you': typeof EndUserWaitingOnYouRoute
  '/group-legal/evaluations': typeof GroupLegalEvaluationsRoute
  '/group-legal/products': typeof GroupLegalProductsRoute
  '/group-legal/tools': typeof GroupLegalToolsRoute
  '/admin/administrators': typeof AdminAdministratorsLazyRoute
  '/admin/analytics': typeof AdminAnalyticsLazyRoute
  '/admin/business-units': typeof AdminBusinessUnitsLazyRoute
  '/admin/connectors': typeof AdminConnectorsLazyRoute
  '/admin/dashboard': typeof AdminDashboardLazyRoute
  '/admin/domains': typeof AdminDomainsLazyRoute
  '/admin/group-contracts': typeof AdminGroupContractsLazyRoute
  '/admin/policies': typeof AdminPoliciesLazyRoute
  '/admin/settings': typeof AdminSettingsLazyRoute
  '/admin/tools': typeof AdminToolsLazyRoute
  '/admin/web-config': typeof AdminWebConfigLazyRoute
  '/bu-admin/dashboard': typeof BuAdminDashboardLazyRoute
  '/bu-admin/evaluation-steps': typeof BuAdminEvaluationStepsLazyRoute
  '/bu-admin/settings': typeof BuAdminSettingsLazyRoute
  '/end-user/community': typeof EndUserCommunityLazyRoute
  '/end-user/dashboard': typeof EndUserDashboardLazyRoute
  '/end-user/policies': typeof EndUserPoliciesLazyRoute
  '/end-user/settings': typeof EndUserSettingsLazyRoute
  '/group-legal/contracted': typeof GroupLegalContractedLazyRoute
  '/group-legal/dashboard': typeof GroupLegalDashboardLazyRoute
  '/group-legal/declined': typeof GroupLegalDeclinedLazyRoute
  '/group-legal/negotiation': typeof GroupLegalNegotiationLazyRoute
  '/group-legal/pending': typeof GroupLegalPendingLazyRoute
  '/group-legal/requests': typeof GroupLegalRequestsLazyRoute
  '/admin/': typeof AdminIndexRoute
  '/bu-admin/': typeof BuAdminIndexRoute
  '/end-user/': typeof EndUserIndexRoute
  '/group-legal/': typeof GroupLegalIndexRoute
  '/group-legal/products_/$productKey': typeof GroupLegalProductsProductKeyRoute
  '/admin/catalogue_/import': typeof AdminCatalogueImportLazyRoute
  '/bu-admin/requests_/$requestId': typeof BuAdminRequestsRequestIdLazyRoute
  '/bu-admin/tools_/$toolId': typeof BuAdminToolsToolIdLazyRoute
  '/end-user/decisions_/$requestId': typeof EndUserDecisionsRequestIdLazyRoute
  '/end-user/my-requests_/$requestId': typeof EndUserMyRequestsRequestIdLazyRoute
  '/end-user/tools_/$toolId': typeof EndUserToolsToolIdLazyRoute
  '/group-legal/tools_/$productKey': typeof GroupLegalToolsProductKeyLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/bu-admin'
    | '/end-user'
    | '/group-legal'
    | '/login-link-modal'
    | '/onboarding'
    | '/help'
    | '/home'
    | '/login'
    | '/login-link'
    | '/no-access'
    | '/admin/audit-logs'
    | '/admin/bug-reports'
    | '/admin/catalogue'
    | '/admin/categories'
    | '/admin/products'
    | '/admin/users'
    | '/bu-admin/analytics'
    | '/bu-admin/connectors'
    | '/bu-admin/email-templates'
    | '/bu-admin/group-contracts'
    | '/bu-admin/houses'
    | '/bu-admin/policies'
    | '/bu-admin/requests'
    | '/bu-admin/tools'
    | '/bu-admin/tools-import'
    | '/bu-admin/users'
    | '/bu-admin/workflows'
    | '/end-user/approvals'
    | '/end-user/decisions'
    | '/end-user/evaluation-steps'
    | '/end-user/my-requests'
    | '/end-user/my-tools'
    | '/end-user/request-access'
    | '/end-user/tools'
    | '/end-user/waiting-on-you'
    | '/group-legal/evaluations'
    | '/group-legal/products'
    | '/group-legal/tools'
    | '/admin/administrators'
    | '/admin/analytics'
    | '/admin/business-units'
    | '/admin/connectors'
    | '/admin/dashboard'
    | '/admin/domains'
    | '/admin/group-contracts'
    | '/admin/policies'
    | '/admin/settings'
    | '/admin/tools'
    | '/admin/web-config'
    | '/bu-admin/dashboard'
    | '/bu-admin/evaluation-steps'
    | '/bu-admin/settings'
    | '/end-user/community'
    | '/end-user/dashboard'
    | '/end-user/policies'
    | '/end-user/settings'
    | '/group-legal/contracted'
    | '/group-legal/dashboard'
    | '/group-legal/declined'
    | '/group-legal/negotiation'
    | '/group-legal/pending'
    | '/group-legal/requests'
    | '/admin/'
    | '/bu-admin/'
    | '/end-user/'
    | '/group-legal/'
    | '/group-legal/products/$productKey'
    | '/admin/catalogue/import'
    | '/bu-admin/requests/$requestId'
    | '/bu-admin/tools/$toolId'
    | '/end-user/decisions/$requestId'
    | '/end-user/my-requests/$requestId'
    | '/end-user/tools/$toolId'
    | '/group-legal/tools/$productKey'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login-link-modal'
    | '/onboarding'
    | '/help'
    | '/home'
    | '/login'
    | '/login-link'
    | '/no-access'
    | '/admin/audit-logs'
    | '/admin/bug-reports'
    | '/admin/catalogue'
    | '/admin/categories'
    | '/admin/products'
    | '/admin/users'
    | '/bu-admin/analytics'
    | '/bu-admin/connectors'
    | '/bu-admin/email-templates'
    | '/bu-admin/group-contracts'
    | '/bu-admin/houses'
    | '/bu-admin/policies'
    | '/bu-admin/requests'
    | '/bu-admin/tools'
    | '/bu-admin/tools-import'
    | '/bu-admin/users'
    | '/bu-admin/workflows'
    | '/end-user/approvals'
    | '/end-user/decisions'
    | '/end-user/evaluation-steps'
    | '/end-user/my-requests'
    | '/end-user/my-tools'
    | '/end-user/request-access'
    | '/end-user/tools'
    | '/end-user/waiting-on-you'
    | '/group-legal/evaluations'
    | '/group-legal/products'
    | '/group-legal/tools'
    | '/admin/administrators'
    | '/admin/analytics'
    | '/admin/business-units'
    | '/admin/connectors'
    | '/admin/dashboard'
    | '/admin/domains'
    | '/admin/group-contracts'
    | '/admin/policies'
    | '/admin/settings'
    | '/admin/tools'
    | '/admin/web-config'
    | '/bu-admin/dashboard'
    | '/bu-admin/evaluation-steps'
    | '/bu-admin/settings'
    | '/end-user/community'
    | '/end-user/dashboard'
    | '/end-user/policies'
    | '/end-user/settings'
    | '/group-legal/contracted'
    | '/group-legal/dashboard'
    | '/group-legal/declined'
    | '/group-legal/negotiation'
    | '/group-legal/pending'
    | '/group-legal/requests'
    | '/admin'
    | '/bu-admin'
    | '/end-user'
    | '/group-legal'
    | '/group-legal/products/$productKey'
    | '/admin/catalogue/import'
    | '/bu-admin/requests/$requestId'
    | '/bu-admin/tools/$toolId'
    | '/end-user/decisions/$requestId'
    | '/end-user/my-requests/$requestId'
    | '/end-user/tools/$toolId'
    | '/group-legal/tools/$productKey'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/bu-admin'
    | '/end-user'
    | '/group-legal'
    | '/login-link-modal'
    | '/onboarding'
    | '/help'
    | '/home'
    | '/login'
    | '/login-link'
    | '/no-access'
    | '/admin/audit-logs'
    | '/admin/bug-reports'
    | '/admin/catalogue'
    | '/admin/categories'
    | '/admin/products'
    | '/admin/users'
    | '/bu-admin/analytics'
    | '/bu-admin/connectors'
    | '/bu-admin/email-templates'
    | '/bu-admin/group-contracts'
    | '/bu-admin/houses'
    | '/bu-admin/policies'
    | '/bu-admin/requests'
    | '/bu-admin/tools'
    | '/bu-admin/tools-import'
    | '/bu-admin/users'
    | '/bu-admin/workflows'
    | '/end-user/approvals'
    | '/end-user/decisions'
    | '/end-user/evaluation-steps'
    | '/end-user/my-requests'
    | '/end-user/my-tools'
    | '/end-user/request-access'
    | '/end-user/tools'
    | '/end-user/waiting-on-you'
    | '/group-legal/evaluations'
    | '/group-legal/products'
    | '/group-legal/tools'
    | '/admin/administrators'
    | '/admin/analytics'
    | '/admin/business-units'
    | '/admin/connectors'
    | '/admin/dashboard'
    | '/admin/domains'
    | '/admin/group-contracts'
    | '/admin/policies'
    | '/admin/settings'
    | '/admin/tools'
    | '/admin/web-config'
    | '/bu-admin/dashboard'
    | '/bu-admin/evaluation-steps'
    | '/bu-admin/settings'
    | '/end-user/community'
    | '/end-user/dashboard'
    | '/end-user/policies'
    | '/end-user/settings'
    | '/group-legal/contracted'
    | '/group-legal/dashboard'
    | '/group-legal/declined'
    | '/group-legal/negotiation'
    | '/group-legal/pending'
    | '/group-legal/requests'
    | '/admin/'
    | '/bu-admin/'
    | '/end-user/'
    | '/group-legal/'
    | '/group-legal/products_/$productKey'
    | '/admin/catalogue_/import'
    | '/bu-admin/requests_/$requestId'
    | '/bu-admin/tools_/$toolId'
    | '/end-user/decisions_/$requestId'
    | '/end-user/my-requests_/$requestId'
    | '/end-user/tools_/$toolId'
    | '/group-legal/tools_/$productKey'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  BuAdminRouteRoute: typeof BuAdminRouteRouteWithChildren
  EndUserRouteRoute: typeof EndUserRouteRouteWithChildren
  GroupLegalRouteRoute: typeof GroupLegalRouteRouteWithChildren
  LoginLinkModalRoute: typeof LoginLinkModalRoute
  OnboardingRoute: typeof OnboardingRoute
  HelpLazyRoute: typeof HelpLazyRoute
  HomeLazyRoute: typeof HomeLazyRoute
  LoginLazyRoute: typeof LoginLazyRoute
  LoginLinkLazyRoute: typeof LoginLinkLazyRoute
  NoAccessLazyRoute: typeof NoAccessLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/no-access': {
      id: '/no-access'
      path: '/no-access'
      fullPath: '/no-access'
      preLoaderRoute: typeof NoAccessLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login-link': {
      id: '/login-link'
      path: '/login-link'
      fullPath: '/login-link'
      preLoaderRoute: typeof LoginLinkLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help': {
      id: '/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof HelpLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login-link-modal': {
      id: '/login-link-modal'
      path: '/login-link-modal'
      fullPath: '/login-link-modal'
      preLoaderRoute: typeof LoginLinkModalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/group-legal': {
      id: '/group-legal'
      path: '/group-legal'
      fullPath: '/group-legal'
      preLoaderRoute: typeof GroupLegalRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/end-user': {
      id: '/end-user'
      path: '/end-user'
      fullPath: '/end-user'
      preLoaderRoute: typeof EndUserRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bu-admin': {
      id: '/bu-admin'
      path: '/bu-admin'
      fullPath: '/bu-admin'
      preLoaderRoute: typeof BuAdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/group-legal/': {
      id: '/group-legal/'
      path: '/'
      fullPath: '/group-legal/'
      preLoaderRoute: typeof GroupLegalIndexRouteImport
      parentRoute: typeof GroupLegalRouteRoute
    }
    '/end-user/': {
      id: '/end-user/'
      path: '/'
      fullPath: '/end-user/'
      preLoaderRoute: typeof EndUserIndexRouteImport
      parentRoute: typeof EndUserRouteRoute
    }
    '/bu-admin/': {
      id: '/bu-admin/'
      path: '/'
      fullPath: '/bu-admin/'
      preLoaderRoute: typeof BuAdminIndexRouteImport
      parentRoute: typeof BuAdminRouteRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/group-legal/requests': {
      id: '/group-legal/requests'
      path: '/requests'
      fullPath: '/group-legal/requests'
      preLoaderRoute: typeof GroupLegalRequestsLazyRouteImport
      parentRoute: typeof GroupLegalRouteRoute
    }
    '/group-legal/pending': {
      id: '/group-legal/pending'
      path: '/pending'
      fullPath: '/group-legal/pending'
      preLoaderRoute: typeof GroupLegalPendingLazyRouteImport
      parentRoute: typeof GroupLegalRouteRoute
    }
    '/group-legal/negotiation': {
      id: '/group-legal/negotiation'
      path: '/negotiation'
      fullPath: '/group-legal/negotiation'
      preLoaderRoute: typeof GroupLegalNegotiationLazyRouteImport
      parentRoute: typeof GroupLegalRouteRoute
    }
    '/group-legal/declined': {
      id: '/group-legal/declined'
      path: '/declined'
      fullPath: '/group-legal/declined'
      preLoaderRoute: typeof GroupLegalDeclinedLazyRouteImport
      parentRoute: typeof GroupLegalRouteRoute
    }
    '/group-legal/dashboard': {
      id: '/group-legal/dashboard'
      path: '/dashboard'
      fullPath: '/group-legal/dashboard'
      preLoaderRoute: typeof GroupLegalDashboardLazyRouteImport
      parentRoute: typeof GroupLegalRouteRoute
    }
    '/group-legal/contracted': {
      id: '/group-legal/contracted'
      path: '/contracted'
      fullPath: '/group-legal/contracted'
      preLoaderRoute: typeof GroupLegalContractedLazyRouteImport
      parentRoute: typeof GroupLegalRouteRoute
    }
    '/end-user/settings': {
      id: '/end-user/settings'
      path: '/settings'
      fullPath: '/end-user/settings'
      preLoaderRoute: typeof EndUserSettingsLazyRouteImport
      parentRoute: typeof EndUserRouteRoute
    }
    '/end-user/policies': {
      id: '/end-user/policies'
      path: '/policies'
      fullPath: '/end-user/policies'
      preLoaderRoute: typeof EndUserPoliciesLazyRouteImport
      parentRoute: typeof EndUserRouteRoute
    }
    '/end-user/dashboard': {
      id: '/end-user/dashboard'
      path: '/dashboard'
      fullPath: '/end-user/dashboard'
      preLoaderRoute: typeof EndUserDashboardLazyRouteImport
      parentRoute: typeof EndUserRouteRoute
    }
    '/end-user/community': {
      id: '/end-user/community'
      path: '/community'
      fullPath: '/end-user/community'
      preLoaderRoute: typeof EndUserCommunityLazyRouteImport
      parentRoute: typeof EndUserRouteRoute
    }
    '/bu-admin/settings': {
      id: '/bu-admin/settings'
      path: '/settings'
      fullPath: '/bu-admin/settings'
      preLoaderRoute: typeof BuAdminSettingsLazyRouteImport
      parentRoute: typeof BuAdminRouteRoute
    }
    '/bu-admin/evaluation-steps': {
      id: '/bu-admin/evaluation-steps'
      path: '/evaluation-steps'
      fullPath: '/bu-admin/evaluation-steps'
      preLoaderRoute: typeof BuAdminEvaluationStepsLazyRouteImport
      parentRoute: typeof BuAdminRouteRoute
    }
    '/bu-admin/dashboard': {
      id: '/bu-admin/dashboard'
      path: '/dashboard'
      fullPath: '/bu-admin/dashboard'
      preLoaderRoute: typeof BuAdminDashboardLazyRouteImport
      parentRoute: typeof BuAdminRouteRoute
    }
    '/admin/web-config': {
      id: '/admin/web-config'
      path: '/web-config'
      fullPath: '/admin/web-config'
      preLoaderRoute: typeof AdminWebConfigLazyRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/tools': {
      id: '/admin/tools'
      path: '/tools'
      fullPath: '/admin/tools'
      preLoaderRoute: typeof AdminToolsLazyRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsLazyRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/policies': {
      id: '/admin/policies'
      path: '/policies'
      fullPath: '/admin/policies'
      preLoaderRoute: typeof AdminPoliciesLazyRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/group-contracts': {
      id: '/admin/group-contracts'
      path: '/group-contracts'
      fullPath: '/admin/group-contracts'
      preLoaderRoute: typeof AdminGroupContractsLazyRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/domains': {
      id: '/admin/domains'
      path: '/domains'
      fullPath: '/admin/domains'
      preLoaderRoute: typeof AdminDomainsLazyRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/dashboard': {
      id: '/admin/dashboard'
      path: '/dashboard'
      fullPath: '/admin/dashboard'
      preLoaderRoute: typeof AdminDashboardLazyRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/connectors': {
      id: '/admin/connectors'
      path: '/connectors'
      fullPath: '/admin/connectors'
      preLoaderRoute: typeof AdminConnectorsLazyRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/business-units': {
      id: '/admin/business-units'
      path: '/business-units'
      fullPath: '/admin/business-units'
      preLoaderRoute: typeof AdminBusinessUnitsLazyRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/analytics': {
      id: '/admin/analytics'
      path: '/analytics'
      fullPath: '/admin/analytics'
      preLoaderRoute: typeof AdminAnalyticsLazyRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/administrators': {
      id: '/admin/administrators'
      path: '/administrators'
      fullPath: '/admin/administrators'
      preLoaderRoute: typeof AdminAdministratorsLazyRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/group-legal/tools': {
      id: '/group-legal/tools'
      path: '/tools'
      fullPath: '/group-legal/tools'
      preLoaderRoute: typeof GroupLegalToolsRouteImport
      parentRoute: typeof GroupLegalRouteRoute
    }
    '/group-legal/products': {
      id: '/group-legal/products'
      path: '/products'
      fullPath: '/group-legal/products'
      preLoaderRoute: typeof GroupLegalProductsRouteImport
      parentRoute: typeof GroupLegalRouteRoute
    }
    '/group-legal/evaluations': {
      id: '/group-legal/evaluations'
      path: '/evaluations'
      fullPath: '/group-legal/evaluations'
      preLoaderRoute: typeof GroupLegalEvaluationsRouteImport
      parentRoute: typeof GroupLegalRouteRoute
    }
    '/end-user/waiting-on-you': {
      id: '/end-user/waiting-on-you'
      path: '/waiting-on-you'
      fullPath: '/end-user/waiting-on-you'
      preLoaderRoute: typeof EndUserWaitingOnYouRouteImport
      parentRoute: typeof EndUserRouteRoute
    }
    '/end-user/tools': {
      id: '/end-user/tools'
      path: '/tools'
      fullPath: '/end-user/tools'
      preLoaderRoute: typeof EndUserToolsRouteImport
      parentRoute: typeof EndUserRouteRoute
    }
    '/end-user/request-access': {
      id: '/end-user/request-access'
      path: '/request-access'
      fullPath: '/end-user/request-access'
      preLoaderRoute: typeof EndUserRequestAccessRouteImport
      parentRoute: typeof EndUserRouteRoute
    }
    '/end-user/my-tools': {
      id: '/end-user/my-tools'
      path: '/my-tools'
      fullPath: '/end-user/my-tools'
      preLoaderRoute: typeof EndUserMyToolsRouteImport
      parentRoute: typeof EndUserRouteRoute
    }
    '/end-user/my-requests': {
      id: '/end-user/my-requests'
      path: '/my-requests'
      fullPath: '/end-user/my-requests'
      preLoaderRoute: typeof EndUserMyRequestsRouteImport
      parentRoute: typeof EndUserRouteRoute
    }
    '/end-user/evaluation-steps': {
      id: '/end-user/evaluation-steps'
      path: '/evaluation-steps'
      fullPath: '/end-user/evaluation-steps'
      preLoaderRoute: typeof EndUserEvaluationStepsRouteImport
      parentRoute: typeof EndUserRouteRoute
    }
    '/end-user/decisions': {
      id: '/end-user/decisions'
      path: '/decisions'
      fullPath: '/end-user/decisions'
      preLoaderRoute: typeof EndUserDecisionsRouteImport
      parentRoute: typeof EndUserRouteRoute
    }
    '/end-user/approvals': {
      id: '/end-user/approvals'
      path: '/approvals'
      fullPath: '/end-user/approvals'
      preLoaderRoute: typeof EndUserApprovalsRouteImport
      parentRoute: typeof EndUserRouteRoute
    }
    '/bu-admin/workflows': {
      id: '/bu-admin/workflows'
      path: '/workflows'
      fullPath: '/bu-admin/workflows'
      preLoaderRoute: typeof BuAdminWorkflowsRouteImport
      parentRoute: typeof BuAdminRouteRoute
    }
    '/bu-admin/users': {
      id: '/bu-admin/users'
      path: '/users'
      fullPath: '/bu-admin/users'
      preLoaderRoute: typeof BuAdminUsersRouteImport
      parentRoute: typeof BuAdminRouteRoute
    }
    '/bu-admin/tools-import': {
      id: '/bu-admin/tools-import'
      path: '/tools-import'
      fullPath: '/bu-admin/tools-import'
      preLoaderRoute: typeof BuAdminToolsImportRouteImport
      parentRoute: typeof BuAdminRouteRoute
    }
    '/bu-admin/tools': {
      id: '/bu-admin/tools'
      path: '/tools'
      fullPath: '/bu-admin/tools'
      preLoaderRoute: typeof BuAdminToolsRouteImport
      parentRoute: typeof BuAdminRouteRoute
    }
    '/bu-admin/requests': {
      id: '/bu-admin/requests'
      path: '/requests'
      fullPath: '/bu-admin/requests'
      preLoaderRoute: typeof BuAdminRequestsRouteImport
      parentRoute: typeof BuAdminRouteRoute
    }
    '/bu-admin/policies': {
      id: '/bu-admin/policies'
      path: '/policies'
      fullPath: '/bu-admin/policies'
      preLoaderRoute: typeof BuAdminPoliciesRouteImport
      parentRoute: typeof BuAdminRouteRoute
    }
    '/bu-admin/houses': {
      id: '/bu-admin/houses'
      path: '/houses'
      fullPath: '/bu-admin/houses'
      preLoaderRoute: typeof BuAdminHousesRouteImport
      parentRoute: typeof BuAdminRouteRoute
    }
    '/bu-admin/group-contracts': {
      id: '/bu-admin/group-contracts'
      path: '/group-contracts'
      fullPath: '/bu-admin/group-contracts'
      preLoaderRoute: typeof BuAdminGroupContractsRouteImport
      parentRoute: typeof BuAdminRouteRoute
    }
    '/bu-admin/email-templates': {
      id: '/bu-admin/email-templates'
      path: '/email-templates'
      fullPath: '/bu-admin/email-templates'
      preLoaderRoute: typeof BuAdminEmailTemplatesRouteImport
      parentRoute: typeof BuAdminRouteRoute
    }
    '/bu-admin/connectors': {
      id: '/bu-admin/connectors'
      path: '/connectors'
      fullPath: '/bu-admin/connectors'
      preLoaderRoute: typeof BuAdminConnectorsRouteImport
      parentRoute: typeof BuAdminRouteRoute
    }
    '/bu-admin/analytics': {
      id: '/bu-admin/analytics'
      path: '/analytics'
      fullPath: '/bu-admin/analytics'
      preLoaderRoute: typeof BuAdminAnalyticsRouteImport
      parentRoute: typeof BuAdminRouteRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/products': {
      id: '/admin/products'
      path: '/products'
      fullPath: '/admin/products'
      preLoaderRoute: typeof AdminProductsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/categories': {
      id: '/admin/categories'
      path: '/categories'
      fullPath: '/admin/categories'
      preLoaderRoute: typeof AdminCategoriesRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/catalogue': {
      id: '/admin/catalogue'
      path: '/catalogue'
      fullPath: '/admin/catalogue'
      preLoaderRoute: typeof AdminCatalogueRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/bug-reports': {
      id: '/admin/bug-reports'
      path: '/bug-reports'
      fullPath: '/admin/bug-reports'
      preLoaderRoute: typeof AdminBugReportsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/audit-logs': {
      id: '/admin/audit-logs'
      path: '/audit-logs'
      fullPath: '/admin/audit-logs'
      preLoaderRoute: typeof AdminAuditLogsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/group-legal/tools_/$productKey': {
      id: '/group-legal/tools_/$productKey'
      path: '/tools/$productKey'
      fullPath: '/group-legal/tools/$productKey'
      preLoaderRoute: typeof GroupLegalToolsProductKeyLazyRouteImport
      parentRoute: typeof GroupLegalRouteRoute
    }
    '/end-user/tools_/$toolId': {
      id: '/end-user/tools_/$toolId'
      path: '/tools/$toolId'
      fullPath: '/end-user/tools/$toolId'
      preLoaderRoute: typeof EndUserToolsToolIdLazyRouteImport
      parentRoute: typeof EndUserRouteRoute
    }
    '/end-user/my-requests_/$requestId': {
      id: '/end-user/my-requests_/$requestId'
      path: '/my-requests/$requestId'
      fullPath: '/end-user/my-requests/$requestId'
      preLoaderRoute: typeof EndUserMyRequestsRequestIdLazyRouteImport
      parentRoute: typeof EndUserRouteRoute
    }
    '/end-user/decisions_/$requestId': {
      id: '/end-user/decisions_/$requestId'
      path: '/decisions/$requestId'
      fullPath: '/end-user/decisions/$requestId'
      preLoaderRoute: typeof EndUserDecisionsRequestIdLazyRouteImport
      parentRoute: typeof EndUserRouteRoute
    }
    '/bu-admin/tools_/$toolId': {
      id: '/bu-admin/tools_/$toolId'
      path: '/tools/$toolId'
      fullPath: '/bu-admin/tools/$toolId'
      preLoaderRoute: typeof BuAdminToolsToolIdLazyRouteImport
      parentRoute: typeof BuAdminRouteRoute
    }
    '/bu-admin/requests_/$requestId': {
      id: '/bu-admin/requests_/$requestId'
      path: '/requests/$requestId'
      fullPath: '/bu-admin/requests/$requestId'
      preLoaderRoute: typeof BuAdminRequestsRequestIdLazyRouteImport
      parentRoute: typeof BuAdminRouteRoute
    }
    '/admin/catalogue_/import': {
      id: '/admin/catalogue_/import'
      path: '/catalogue/import'
      fullPath: '/admin/catalogue/import'
      preLoaderRoute: typeof AdminCatalogueImportLazyRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/group-legal/products_/$productKey': {
      id: '/group-legal/products_/$productKey'
      path: '/products/$productKey'
      fullPath: '/group-legal/products/$productKey'
      preLoaderRoute: typeof GroupLegalProductsProductKeyRouteImport
      parentRoute: typeof GroupLegalRouteRoute
    }
  }
}

interface AdminRouteRouteChildren {
  AdminAuditLogsRoute: typeof AdminAuditLogsRoute
  AdminBugReportsRoute: typeof AdminBugReportsRoute
  AdminCatalogueRoute: typeof AdminCatalogueRoute
  AdminCategoriesRoute: typeof AdminCategoriesRoute
  AdminProductsRoute: typeof AdminProductsRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminAdministratorsLazyRoute: typeof AdminAdministratorsLazyRoute
  AdminAnalyticsLazyRoute: typeof AdminAnalyticsLazyRoute
  AdminBusinessUnitsLazyRoute: typeof AdminBusinessUnitsLazyRoute
  AdminConnectorsLazyRoute: typeof AdminConnectorsLazyRoute
  AdminDashboardLazyRoute: typeof AdminDashboardLazyRoute
  AdminDomainsLazyRoute: typeof AdminDomainsLazyRoute
  AdminGroupContractsLazyRoute: typeof AdminGroupContractsLazyRoute
  AdminPoliciesLazyRoute: typeof AdminPoliciesLazyRoute
  AdminSettingsLazyRoute: typeof AdminSettingsLazyRoute
  AdminToolsLazyRoute: typeof AdminToolsLazyRoute
  AdminWebConfigLazyRoute: typeof AdminWebConfigLazyRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminCatalogueImportLazyRoute: typeof AdminCatalogueImportLazyRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminAuditLogsRoute: AdminAuditLogsRoute,
  AdminBugReportsRoute: AdminBugReportsRoute,
  AdminCatalogueRoute: AdminCatalogueRoute,
  AdminCategoriesRoute: AdminCategoriesRoute,
  AdminProductsRoute: AdminProductsRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminAdministratorsLazyRoute: AdminAdministratorsLazyRoute,
  AdminAnalyticsLazyRoute: AdminAnalyticsLazyRoute,
  AdminBusinessUnitsLazyRoute: AdminBusinessUnitsLazyRoute,
  AdminConnectorsLazyRoute: AdminConnectorsLazyRoute,
  AdminDashboardLazyRoute: AdminDashboardLazyRoute,
  AdminDomainsLazyRoute: AdminDomainsLazyRoute,
  AdminGroupContractsLazyRoute: AdminGroupContractsLazyRoute,
  AdminPoliciesLazyRoute: AdminPoliciesLazyRoute,
  AdminSettingsLazyRoute: AdminSettingsLazyRoute,
  AdminToolsLazyRoute: AdminToolsLazyRoute,
  AdminWebConfigLazyRoute: AdminWebConfigLazyRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminCatalogueImportLazyRoute: AdminCatalogueImportLazyRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

interface BuAdminRouteRouteChildren {
  BuAdminAnalyticsRoute: typeof BuAdminAnalyticsRoute
  BuAdminConnectorsRoute: typeof BuAdminConnectorsRoute
  BuAdminEmailTemplatesRoute: typeof BuAdminEmailTemplatesRoute
  BuAdminGroupContractsRoute: typeof BuAdminGroupContractsRoute
  BuAdminHousesRoute: typeof BuAdminHousesRoute
  BuAdminPoliciesRoute: typeof BuAdminPoliciesRoute
  BuAdminRequestsRoute: typeof BuAdminRequestsRoute
  BuAdminToolsRoute: typeof BuAdminToolsRoute
  BuAdminToolsImportRoute: typeof BuAdminToolsImportRoute
  BuAdminUsersRoute: typeof BuAdminUsersRoute
  BuAdminWorkflowsRoute: typeof BuAdminWorkflowsRoute
  BuAdminDashboardLazyRoute: typeof BuAdminDashboardLazyRoute
  BuAdminEvaluationStepsLazyRoute: typeof BuAdminEvaluationStepsLazyRoute
  BuAdminSettingsLazyRoute: typeof BuAdminSettingsLazyRoute
  BuAdminIndexRoute: typeof BuAdminIndexRoute
  BuAdminRequestsRequestIdLazyRoute: typeof BuAdminRequestsRequestIdLazyRoute
  BuAdminToolsToolIdLazyRoute: typeof BuAdminToolsToolIdLazyRoute
}

const BuAdminRouteRouteChildren: BuAdminRouteRouteChildren = {
  BuAdminAnalyticsRoute: BuAdminAnalyticsRoute,
  BuAdminConnectorsRoute: BuAdminConnectorsRoute,
  BuAdminEmailTemplatesRoute: BuAdminEmailTemplatesRoute,
  BuAdminGroupContractsRoute: BuAdminGroupContractsRoute,
  BuAdminHousesRoute: BuAdminHousesRoute,
  BuAdminPoliciesRoute: BuAdminPoliciesRoute,
  BuAdminRequestsRoute: BuAdminRequestsRoute,
  BuAdminToolsRoute: BuAdminToolsRoute,
  BuAdminToolsImportRoute: BuAdminToolsImportRoute,
  BuAdminUsersRoute: BuAdminUsersRoute,
  BuAdminWorkflowsRoute: BuAdminWorkflowsRoute,
  BuAdminDashboardLazyRoute: BuAdminDashboardLazyRoute,
  BuAdminEvaluationStepsLazyRoute: BuAdminEvaluationStepsLazyRoute,
  BuAdminSettingsLazyRoute: BuAdminSettingsLazyRoute,
  BuAdminIndexRoute: BuAdminIndexRoute,
  BuAdminRequestsRequestIdLazyRoute: BuAdminRequestsRequestIdLazyRoute,
  BuAdminToolsToolIdLazyRoute: BuAdminToolsToolIdLazyRoute,
}

const BuAdminRouteRouteWithChildren = BuAdminRouteRoute._addFileChildren(
  BuAdminRouteRouteChildren,
)

interface EndUserRouteRouteChildren {
  EndUserApprovalsRoute: typeof EndUserApprovalsRoute
  EndUserDecisionsRoute: typeof EndUserDecisionsRoute
  EndUserEvaluationStepsRoute: typeof EndUserEvaluationStepsRoute
  EndUserMyRequestsRoute: typeof EndUserMyRequestsRoute
  EndUserMyToolsRoute: typeof EndUserMyToolsRoute
  EndUserRequestAccessRoute: typeof EndUserRequestAccessRoute
  EndUserToolsRoute: typeof EndUserToolsRoute
  EndUserWaitingOnYouRoute: typeof EndUserWaitingOnYouRoute
  EndUserCommunityLazyRoute: typeof EndUserCommunityLazyRoute
  EndUserDashboardLazyRoute: typeof EndUserDashboardLazyRoute
  EndUserPoliciesLazyRoute: typeof EndUserPoliciesLazyRoute
  EndUserSettingsLazyRoute: typeof EndUserSettingsLazyRoute
  EndUserIndexRoute: typeof EndUserIndexRoute
  EndUserDecisionsRequestIdLazyRoute: typeof EndUserDecisionsRequestIdLazyRoute
  EndUserMyRequestsRequestIdLazyRoute: typeof EndUserMyRequestsRequestIdLazyRoute
  EndUserToolsToolIdLazyRoute: typeof EndUserToolsToolIdLazyRoute
}

const EndUserRouteRouteChildren: EndUserRouteRouteChildren = {
  EndUserApprovalsRoute: EndUserApprovalsRoute,
  EndUserDecisionsRoute: EndUserDecisionsRoute,
  EndUserEvaluationStepsRoute: EndUserEvaluationStepsRoute,
  EndUserMyRequestsRoute: EndUserMyRequestsRoute,
  EndUserMyToolsRoute: EndUserMyToolsRoute,
  EndUserRequestAccessRoute: EndUserRequestAccessRoute,
  EndUserToolsRoute: EndUserToolsRoute,
  EndUserWaitingOnYouRoute: EndUserWaitingOnYouRoute,
  EndUserCommunityLazyRoute: EndUserCommunityLazyRoute,
  EndUserDashboardLazyRoute: EndUserDashboardLazyRoute,
  EndUserPoliciesLazyRoute: EndUserPoliciesLazyRoute,
  EndUserSettingsLazyRoute: EndUserSettingsLazyRoute,
  EndUserIndexRoute: EndUserIndexRoute,
  EndUserDecisionsRequestIdLazyRoute: EndUserDecisionsRequestIdLazyRoute,
  EndUserMyRequestsRequestIdLazyRoute: EndUserMyRequestsRequestIdLazyRoute,
  EndUserToolsToolIdLazyRoute: EndUserToolsToolIdLazyRoute,
}

const EndUserRouteRouteWithChildren = EndUserRouteRoute._addFileChildren(
  EndUserRouteRouteChildren,
)

interface GroupLegalRouteRouteChildren {
  GroupLegalEvaluationsRoute: typeof GroupLegalEvaluationsRoute
  GroupLegalProductsRoute: typeof GroupLegalProductsRoute
  GroupLegalToolsRoute: typeof GroupLegalToolsRoute
  GroupLegalContractedLazyRoute: typeof GroupLegalContractedLazyRoute
  GroupLegalDashboardLazyRoute: typeof GroupLegalDashboardLazyRoute
  GroupLegalDeclinedLazyRoute: typeof GroupLegalDeclinedLazyRoute
  GroupLegalNegotiationLazyRoute: typeof GroupLegalNegotiationLazyRoute
  GroupLegalPendingLazyRoute: typeof GroupLegalPendingLazyRoute
  GroupLegalRequestsLazyRoute: typeof GroupLegalRequestsLazyRoute
  GroupLegalIndexRoute: typeof GroupLegalIndexRoute
  GroupLegalProductsProductKeyRoute: typeof GroupLegalProductsProductKeyRoute
  GroupLegalToolsProductKeyLazyRoute: typeof GroupLegalToolsProductKeyLazyRoute
}

const GroupLegalRouteRouteChildren: GroupLegalRouteRouteChildren = {
  GroupLegalEvaluationsRoute: GroupLegalEvaluationsRoute,
  GroupLegalProductsRoute: GroupLegalProductsRoute,
  GroupLegalToolsRoute: GroupLegalToolsRoute,
  GroupLegalContractedLazyRoute: GroupLegalContractedLazyRoute,
  GroupLegalDashboardLazyRoute: GroupLegalDashboardLazyRoute,
  GroupLegalDeclinedLazyRoute: GroupLegalDeclinedLazyRoute,
  GroupLegalNegotiationLazyRoute: GroupLegalNegotiationLazyRoute,
  GroupLegalPendingLazyRoute: GroupLegalPendingLazyRoute,
  GroupLegalRequestsLazyRoute: GroupLegalRequestsLazyRoute,
  GroupLegalIndexRoute: GroupLegalIndexRoute,
  GroupLegalProductsProductKeyRoute: GroupLegalProductsProductKeyRoute,
  GroupLegalToolsProductKeyLazyRoute: GroupLegalToolsProductKeyLazyRoute,
}

const GroupLegalRouteRouteWithChildren = GroupLegalRouteRoute._addFileChildren(
  GroupLegalRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  BuAdminRouteRoute: BuAdminRouteRouteWithChildren,
  EndUserRouteRoute: EndUserRouteRouteWithChildren,
  GroupLegalRouteRoute: GroupLegalRouteRouteWithChildren,
  LoginLinkModalRoute: LoginLinkModalRoute,
  OnboardingRoute: OnboardingRoute,
  HelpLazyRoute: HelpLazyRoute,
  HomeLazyRoute: HomeLazyRoute,
  LoginLazyRoute: LoginLazyRoute,
  LoginLinkLazyRoute: LoginLinkLazyRoute,
  NoAccessLazyRoute: NoAccessLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
